import { render } from "./OrderBonus.vue?vue&type=template&id=d299897c&ts=true"
import script from "./OrderBonus.vue?vue&type=script&lang=ts"
export * from "./OrderBonus.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__